import React, { useEffect, useState } from "react";
import {
  useTable,
  usePagination,
  useSortBy,
  useExpanded,
  useGlobalFilter,
  useRowSelect
} from "react-table";
import { Button } from "react-bootstrap";
import { CONTAINERMASTER_DATA_COLUMNS } from "../../columns/containerMasterColumns";
// import MainTablePagination from "./MainTablePagination";
import ContainerMasterActionCenter from "../action-center/ContainerMasterActionCenter";
import { defaultContainerColumn } from "../cells/editable/containerMasterEditableCell";
import ContainerAdd from "../ContainerAdd";
import { filter } from "lodash";
import MainTablePaginationAdv from "./MainTablePaginationAdv";
import { TableCheckbox } from "./TableCheckbox";
import InvoicePackagingUploadModal from "../InvoicePackagingUploadModal";
import InvoicePackagingPDFViewer from "../InvoicePackagingPDFViewer";
import moment from "moment";
import { getUser } from "../../../services/authService";
import { dispatcher } from "../../../store/storeHelpers";
import * as actionTypes from "../../../store/ActionTypes"
import { toast } from "react-toastify";
import { updateContainerData, updateAggregateContainerData, updateFiveMContainerData } from "../../../services/ContainerMasterService";
import { invPackingDocValidation,viewDoc, } from "../../../services/dataService";
import FactoryOutModal from "../FactoryOutModal";
import {getContainerMasterDocs} from "../../../services/ContainerMasterService";
import { InsertInvoiceDocDetailsForOCR, updateinvoicedetails ,getInvoiceDocumentDetails,uploadInvoiceDocOCR,InsertOCRApiResponseLog} from "../../../services/OCRDataService";
import axios from "axios";
import {viewSIDoc } from "../../../services/tractorDataService";



function ContainerMasterDataTable({
  tableData,
  date,
  setDate,
  dataExportHandler,
  subModule,
  setTableData,
  filteredUserAccessData,
  noDataState,
  setNoDataState,
  setGetOutCounterData,
}) {
  const [columns] = useState(CONTAINERMASTER_DATA_COLUMNS);
  const [showContainerAdd, setShowContainerAdd] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(null);
  const [showViewModal, setShowViewModal] = useState(null);
  const [disableGateOutBtn, setDisableGateOutBtn] = useState(false)
  const [showFactoryOutModal, setShowFactoryOutModal] = useState(null);
  const [getCellData, setGetCellData] = useState({})

  const idarray=  [] ;


  const user = getUser()
  var allowToEdit = filter(filteredUserAccessData,{Edit:1}).length > 0
  var allowToUpload = filter(filteredUserAccessData,{Upload:1}).length > 0

  const updateCellDataForFactoryIn = (
    rowIndex,
    columnId,
    dateValue,
    timeValue
  ) => {
    setTableData((old) =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: `${dateValue}T${timeValue}`,
          };
        }
        return row;
      })
    );
  };

  const updateCellData = (rowIndex, columnId, value) => {
    setTableData((old) =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          };
        }
        return row;
      })
    );
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    state,
    setPageSize,
    canPreviousPage,
    setGlobalFilter,
    prepareRow,
    selectedFlatRows,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data: tableData,
  
      // data,
      defaultColumn: defaultContainerColumn,
      autoResetPage: false,
      initialState: { pageSize: 50},
      autoResetExpanded: false,
      autoResetGlobalFilter: false,
      updateCellData,
      allowToEdit,
      updateCellDataForFactoryIn
    },
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <TableCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <TableCheckbox {...row.getToggleRowSelectedProps()}  />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  const { pageIndex, pageSize, globalFilter } = state;

 { selectedFlatRows.forEach(element => {
  idarray.push(element.id) 
});
}


  const cellRenderHandler = (cell) => {
    if (cell.column.id === "add_Data") return "addData";
    if (cell.column.id === "upload_doc") return "upload";
    if (cell.column.id === "view_doc") return "view";
    if (cell.column.id === "Gate_Out_Date") return "action";
    else return "data";
  };

  useEffect(()=>{
    var gateOutDataForCount = [];
		for (let i = 0; i < tableData.length; i++) {
			if (tableData[i]["Gate_Out_Date"]) {
				gateOutDataForCount.push({
					...tableData[i],
				});
			}
		}
		setGetOutCounterData({
			GateOut: gateOutDataForCount,
			TotalGateOut: tableData,
		});
  },[setGetOutCounterData, tableData])

  async function getInvoiceDocAndSendToKlearStack(cell) {
    try {
      const invoiceNumber = cell.row.original.invoice;
      const containerId = cell.row.original.ContainerMasterId;
      const bookingDocName = cell.row.original.BookingDocument;
      let savedReferenceNumber = null;
      let isFirstUpload = true;
  
      const allDocs = [];
  
      // Step 1: Get invoice documents
      const response = await getContainerMasterDocs(containerId);
      for (const doc of response.data) {
        const docName = doc.InvoicePackingDoc;
        if (docName) {
          allDocs.push({
            name: docName,
            type: "Invoices",
          });
        }
      }
  
      // Step 2: Add booking/shipping instruction document
      if (bookingDocName) {
        allDocs.push({
          name: bookingDocName,
          type: "BookingConfirmation",
        });
      }
  
      // Step 3: Process each document
      for (const doc of allDocs) {
        const viewFunc = doc.type === "Invoices" ? viewDoc : viewSIDoc;
        const docResponse = await viewFunc(doc.name);
  
        if (docResponse?.data?.Message) {
          const docLink = docResponse.data.Message;
          const fileBlob = await downloadFile(docLink);
          if (!fileBlob) continue;
  
          // Step 4: Insert metadata
          const insertRes = await InsertInvoiceDocDetailsForOCR([
            {
              invoiceNumber,
              documentName: doc.name,
              documentLink: docLink,
              InvoiceRefId: containerId,
              documentType: doc.type,
              isSupplierInv: false,
              isSentToKlearStack: 1,
              UploadBy: getUser().uid,
            },
          ]);
  
          const docId = insertRes?.data?.InvoiceDocId;
          if (!docId) continue;
  
          const invoiceDetails = await getInvoiceDocumentDetails(docId);
          const invoiceDocs = Array.isArray(invoiceDetails?.data) && invoiceDetails.data.length > 0
            ? invoiceDetails.data
            : [{ InvoiceDocId: docId }];
  
          // Step 5: Upload to KlearStack — pass doc.type!
          const uploadResponse = await sendToKlearStack(
            fileBlob,
            doc.name,
            invoiceNumber,
            isFirstUpload,
            doc.type,
            savedReferenceNumber
          );
  
          if (uploadResponse) {
            await InsertOCRApiResponseLog({
              invoiceNumber,
              isSupplierInv: false,
              apiPayload: JSON.stringify({ fileName: doc.name }),
              apiResponseCode: 200,
              apiResponseMessage: "Success",
              apiResponse: JSON.stringify(uploadResponse),
              createdBy: getUser().uid,
            });
  
            if (isFirstUpload && uploadResponse.set_reference_number) {
              savedReferenceNumber = uploadResponse.set_reference_number;
  
              for (const docItem of invoiceDocs) {
                await updateinvoicedetails({
                  ColName: "set_reference_number",
                  Id: docItem.InvoiceDocId,
                  PreValue: null,
                  NewValue: savedReferenceNumber,
                  CreatedBy: getUser().uid,
                });
              }
            }
  
            for (const docItem of invoiceDocs) {
              await updateinvoicedetails({
                ColName: "isSentToKlearStack",
                Id: docItem.InvoiceDocId,
                PreValue: 0,
                NewValue: 1,
                CreatedBy: getUser().uid,
              });
  
              await updateinvoicedetails({
                ColName: "isDocumentSendTOVizio",
                Id: docItem.InvoiceDocId,
                PreValue: 0,
                NewValue: 1,
                CreatedBy: getUser().uid,
              });
            }
  
            isFirstUpload = false;
          } else {
            console.error(`Upload failed for ${doc.name}`);
          }
        }
      }
    } catch (error) {
      toast.error(error?.response?.Message || "Failed to process documents");
    }
  }
  
  
  
  

// async function getInvoiceDocAndSendToKlearStack(cell) {
//   try {
//     let savedReferenceNumber = null;
//     let isFirstUpload = true;

//     // Step 1: Fetch all invoice documents for the given container
//     const response = await getContainerMasterDocs(cell.row.original.ContainerMasterId);

//     for (let i = 0; i < response.data.length; i++) {
//       let docName = response.data[i].InvoicePackingDoc || "";

//       if (docName) {
//         const invoiceResponse = await viewDoc(docName);


//         if (invoiceResponse?.data?.Message) {
//           const docLink = invoiceResponse.data.Message;
//           const fileBlob = await downloadFile(docLink);
//           const invoiceNumber = cell.row.original.invoice;

//           if (fileBlob) {
//             // Step 2: Insert document metadata
//             const uploadedFileMetaData = {
//               invoiceNumber,
//               documentName: docName,
//               documentLink: docLink,
//               documentType: "Invoice",
//               InvoiceRefId: cell.row.original.ContainerMasterId,
//               isSupplierInv: false,
//               isSentToKlearStack: 1,
//               UploadBy: getUser().uid
//             };

//             const insertResponse = await InsertInvoiceDocDetailsForOCR([uploadedFileMetaData]);
//             const InvoiceDocId = insertResponse?.data?.InvoiceDocId;

//             if (!InvoiceDocId) {
             
//               continue;
//             }

//             // Log DB insert
//             const dbLogData = {
//               invoiceNumber,
//               isSupplierInv: false,
//               apiPayload: JSON.stringify(uploadedFileMetaData),
//               apiResponseCode: 200,
//               apiResponseMessage: insertResponse.statusText,
//               apiResponse: JSON.stringify(insertResponse.data),
//               createdBy: getUser().uid,
//             };
//             await InsertOCRApiResponseLog(dbLogData);

//             // Step 3: Fetch invoice details
//             const invoiceDetails = await getInvoiceDocumentDetails(InvoiceDocId);
//             const invoiceDocs = Array.isArray(invoiceDetails?.data) && invoiceDetails.data.length > 0
//               ? invoiceDetails.data
//               : [{ InvoiceDocId }];

//             try {
//               // Step 4: Upload to KlearStack
//               const uploadResponse = await sendToKlearStack(fileBlob, docName, invoiceNumber, isFirstUpload, savedReferenceNumber);

//               // Log KlearStack upload
//               const klearStackLogData = {
//                 invoiceNumber,

//                 isSupplierInv: false,
//                 apiPayload: JSON.stringify({ fileName: docName }),
//                 apiResponseCode: 200,
//                 apiResponseMessage: uploadResponse.statusText,
//                 apiResponse: JSON.stringify(uploadResponse.data),
//                 createdBy: getUser().uid,
//               };
//               await InsertOCRApiResponseLog(klearStackLogData);

//               // Step 5: Save set_reference_number if first upload
//               if (isFirstUpload && uploadResponse?.set_reference_number) {
//                 savedReferenceNumber = uploadResponse.set_reference_number;

//                 for (const doc of invoiceDocs) {
//                   await updateinvoicedetails({
//                     ColName: "set_reference_number",
//                     Id: doc.InvoiceDocId,
//                     PreValue: null,
//                     NewValue: savedReferenceNumber,
//                     CreatedBy: getUser().uid,
//                   });
//                 }
//               }

//               // Step 6: Update flags for every file
//               for (const doc of invoiceDocs) {
//                 await updateinvoicedetails({
//                   ColName: "isSentToKlearStack",
//                   Id: doc.InvoiceDocId,
//                   PreValue: 0,
//                   NewValue: 1,
//                   CreatedBy: getUser().uid,
//                 });

//                 await updateinvoicedetails({
//                   ColName: "isDocumentSendTOVizio",
//                   Id: doc.InvoiceDocId,
//                   PreValue: 0,
//                   NewValue: 1,
//                   CreatedBy: getUser().uid,
//                 });
//               }

//             } catch (error) {
//               console.error(`KlearStack Upload failed for ${docName}:`, error.response?.data || error.message);
//             }

//             isFirstUpload = false;

//             // Step 7: Add a delay to avoid overloading the server
//             if (i < response.data.length - 1) {
//               await new Promise(resolve => setTimeout(resolve, 2000));
//             }
//           }
//         }
//       }
//     }

//   } catch (error) {

//     toast.error(error?.response?.Message || "Failed to process documents");
//   }
// }







  async function downloadFile(fileUrl) {
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error("Failed to download file");
      return await response.blob(); // Convert response to Blob
    } catch (error) {
     
      return null;
    }
  }  
 async function sendToKlearStack(fileBlob, fileName, InvoiceNumber, isFirstUpload,doctype, savedReferenceNumber) {
    let invoiceNumber = InvoiceNumber || fileName.replace(/\..+$/, ""); 


    if (fileBlob.type !== "application/pdf" && !fileName.toLowerCase().endsWith(".pdf")) {
        toast.error("Only PDF files are allowed.");
       
        return;
    }

    try {
      
    
        
        const formData = new FormData();
        formData.append("file", fileBlob, fileName); 
        formData.append("invoiceNumber", invoiceNumber);
        formData.append("documentType", doctype);
        formData.append("set_name", invoiceNumber);
        formData.append("create_new_set", isFirstUpload ? "true" : "false");

        if (!isFirstUpload && savedReferenceNumber) {
            formData.append("set_reference_number", savedReferenceNumber);
        }

       

        const response = await axios.post(
            "https://vizioapi.quloi.com/AryabhattaDev/uploadFile",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data" 
                }
            }
        );

        if (isFirstUpload && response.data.set_reference_number) {
            localStorage.setItem("savedReferenceNumber", response.data.set_reference_number);
        }

        // toast.success("PDF uploaded to KlearStack successfully!");
        return response.data;

    } catch (error) {
        
        // toast.error("Upload failed. Check console for details.");
        return null;
    }
}


  
  

  async function actionClickHandlerForDischarge(cell) {
    console.log(cell.row.original.BookingDocument)
    setGetCellData(cell)
    
 
    getInvoiceDocAndSendToKlearStack(cell)

    try {
      const validationResponse = await invPackingDocValidation(cell.row.original.ContainerMasterId, cell.row.original.DataOf)
      if (validationResponse.data[0]["Successcode"] === 400) {
        setShowFactoryOutModal(validationResponse.data[0]["Message"]);
      } else {
        if (cell.row.original.DataOf === "TRACTOR") {
          setDisableGateOutBtn(true);
          updateContainerData({
            Id: `${cell.row.original["ContainerMasterId"]}`,
            columnName: "Gate_Out_Date",
            prevVal: "-",
            value: moment().format("YYYY-MM-DD HH:mm:ss"),
            UserId: user.uid,
          });
          dispatcher(actionTypes.CONTAINER_GATE_OUT, {
            Id: `${cell.row.original["ContainerMasterId"]}`,
            columnName: "Gate_Out_Date",
            prevVal: "-",
            value: moment().format("YYYY-MM-DD hh:mm A"),
            UserId: user.uid,
            invoicenumber : cell.row.original["invoice"]
          });
          setDisableGateOutBtn(false);
        }
        if (cell.row.original.DataOf === "AGGREGATE") {
          setDisableGateOutBtn(true);
          updateAggregateContainerData({
            Id: `${cell.row.original["ContainerMasterId"]}`,
            columnName: "Gate_Out_Date",
            prevVal: "-",
            value: moment().format("YYYY-MM-DD HH:mm:ss"),
            UserId: user.uid,
          });
          dispatcher(actionTypes.CONTAINER_GATE_OUT, {
            Id: `${cell.row.original["ContainerMasterId"]}`,
            columnName: "Gate_Out_Date",
            prevVal: "-",
            value: moment().format("YYYY-MM-DD hh:mm A"),
            UserId: user.uid,
            invoicenumber : cell.row.original["invoice"]
          });
          setDisableGateOutBtn(false);
        }
        if (cell.row.original.DataOf === "5M") {
          setDisableGateOutBtn(true);
          updateFiveMContainerData({
            Id: `${cell.row.original["ContainerMasterId"]}`,
            columnName: "Gate_Out_Date",
            prevVal: "-",
            value: moment().format("YYYY-MM-DD HH:mm:ss"),
            UserId: user.uid,
          });
          dispatcher(actionTypes.CONTAINER_GATE_OUT, {
            Id: `${cell.row.original["ContainerMasterId"]}`,
            columnName: "Gate_Out_Date",
            prevVal: "-",
            value: moment().format("YYYY-MM-DD hh:mm A"),
            UserId: user.uid,
            invoicenumber : cell.row.original["invoice"]
          });
          setDisableGateOutBtn(false);
        }
        toast.success(
          `"Factory Out Date & Time" column updated with "${moment().format(
            "DD-MM-YYYY hh:mm A"
          )}"`
        );
      }
    } catch (error) {
      setDisableGateOutBtn(false)
    }
  }

  function addContainerModalClickhandler(cell) {
    setShowContainerAdd(cell);
  }

  function uploadModalClickhandler(cell) {
    setShowUploadModal(cell);
  }
  function viewModalClickhandler(cell) {
    setShowViewModal(cell);
  }

  return (
    <>
    {showFactoryOutModal && <FactoryOutModal
      show={showFactoryOutModal}
      hide={()=>setShowFactoryOutModal(null)}
      cell={getCellData}
      user={user}
      setDisableGateOutBtn={setDisableGateOutBtn}
    />}
      <div className="table_actions_containerMaster">
        <ContainerMasterActionCenter
          date={date}
          setDate={setDate}
          dataExportHandler={dataExportHandler}
          tableData={tableData}
          selectedFlatRows={selectedFlatRows}
          subModule={subModule}
          allColumns={allColumns}
          getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
          type={"Daily"}
          filteredUserAccessData={filteredUserAccessData}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          setNoDataState={setNoDataState}
        />
        {showContainerAdd && (
          <ContainerAdd
            show={showContainerAdd}
            hide={() => setShowContainerAdd(null)}
            tableData={tableData}
            showFactoryOutModal={showFactoryOutModal}
            setShowFactoryOutModal={setShowFactoryOutModal}
          />
        )}
      </div>
      {!noDataState && (
        <>
          <div className="table_container_containerMaster">
            <table {...getTableProps()} className="table mtbs">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        {column.id !== "selection" && (
                          <i
                            className={
                              column.isSorted
                                ? column.isSortedDesc
                                  ? "fi fi-rr-angle-small-down head-icon"
                                  : "fi fi-rr-angle-small-up head-icon"
                                : "fi fi-rr-circle-small head-icon w"
                            }
                          ></i>
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td
                          style={idarray.includes(cell.row.id)?{ backgroundColor: "lightblue" }:null}
                            {...cell.getCellProps()}
                            
                            className={
                              cell.row.subRows.length !== 0
                                ? "main-row"
                                : "sub-row"
                            }
                            
                            
                          >
                            <div className="cell-wrap">
                              {cellRenderHandler(cell) === "addData" && (
                                <Button
                                  className="btn btn-sm btn-tbl"
                                  style={{
                                    height: "35px",
                                    marginRight: "40px",
                                  }}
                                  onClick={() =>
                                    addContainerModalClickhandler(cell)
                                  }
                                  disabled={(cell.row.original.Back_To_Town === 0 && !cell.row.original.Gate_Out_Date) ? false : (cell.row.original.Back_To_Town === 0 && cell.row.original.Gate_Out_Date) ? true : (cell.row.original.Back_To_Town === 1 && cell.row.original.Gate_Out_Date) ? false : (cell.row.original.Back_To_Town === 1 && !cell.row.original.Gate_Out_Date) ? false : true || !allowToEdit}
                                >
                                  <i class="bx bxs-edit uploadSymbol"></i>
                                </Button>
                              )}
                              {cellRenderHandler(cell) === "upload" && (
                                <Button
                                  className="btn btn-sm btn-tbl"
                                  style={{
                                    height: "35px",
                                    marginRight: "60px",
                                  }}
                                  onClick={() => uploadModalClickhandler(cell)}
                                  disabled={!allowToUpload}
                                >
                                  <i class="bx bx-upload uploadSymbol"></i>
                                </Button>
                              )}
                              {cellRenderHandler(cell) === "view" && (
                                <Button
                                  className="btn btn-sm btn-tbl"
                                  style={{
                                    height: "35px",
                                    marginRight: "50px",
                                  }}
                                  onClick={() => viewModalClickhandler(cell)}
                                  // disabled={!cell.row.original.InvoicePackingDoc}
                                >
                                  <i
                                    class="bx bx-right-top-arrow-circle"
                                    style={{ transform: "scale(2)" }}
                                  ></i>
                                </Button>
                              )}
                              {(cellRenderHandler(cell) === "data" || cell.column.id === "Gate_Out_Date") &&
                                cell.render("Cell")}
                                {cellRenderHandler(cell) === "action" && (
                                  <Button
                                    className="btn btn-sm btn-tbl gateOutBtn"
                                    style={{
                                      height: "35px",
                                      position: "relative",
                                      left: "0px",
                                    }}
                                    onClick={() =>
                                      actionClickHandlerForDischarge(cell)
                                    }
                                    disabled={
                                      cell.row.original.Gate_Out_Date ||
                                      !allowToEdit || disableGateOutBtn
                                    }
                                  >
                                    <i class="bx bx-log-out-circle gateOutSymbol"></i>
                                  </Button>
                                )}
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <MainTablePaginationAdv
            nextPage={nextPage}
            previousPage={previousPage}
            canNextPage={canNextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            pageSize={pageSize}
            canPreviousPage={canPreviousPage}
            setPageSize={setPageSize}
            gotoPage={gotoPage}
            pageCount={pageCount}
          />
          {showUploadModal && (
            <InvoicePackagingUploadModal
              show={showUploadModal}
              hide={() => setShowUploadModal(null)}
            />
          )}
          {showViewModal && (
            <InvoicePackagingPDFViewer
              show={showViewModal}
              hide={() => setShowViewModal(null)}
              date={date}
              type="departureScreen"
            />
          )}
        </>
      )}
    </>
  );
}

export default ContainerMasterDataTable;
